import { render, staticRenderFns } from "./PanelCompetitionSetting.vue?vue&type=template&id=16c64d3e&scoped=true&"
import script from "./PanelCompetitionSetting.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSetting.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSetting.vue?vue&type=style&index=0&id=16c64d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c64d3e",
  null
  
)

export default component.exports